import { lazyImport } from './import'

export default lazyImport(
  () => import('./EntryPoint.client'),
  'Entrypoint.client'
)
